module.exports = __webpack_public_path__ + "img/empowering-learners.51c0e2da.svg";